import React, { memo } from 'react'

import withHide from 'components/withHide'

import { Game } from '../../Game'
import { useGamesFromSlugs } from '../CategoriesGrid/hooks'
import { SelectedFilters } from './SelectedFilters'
import { GamesGridBox } from './styles'
import { useFilteredGames } from './useFilteredGames'

function SelectedGamesGridComponent() {
  const { selectedSlugs, isPending } = useFilteredGames()

  const gamesFromSlugs = useGamesFromSlugs(selectedSlugs)

  if (isPending) {
    // TODO: skeleton
    return null
  }

  return (
    <>
      <SelectedFilters />

      <GamesGridBox>
        {gamesFromSlugs.map((game) => (
          <Game
            key={game.slug}
            game={game}
          />
        ))}
      </GamesGridBox>
    </>
  )
}

export const SelectedGamesGrid = withHide(memo(SelectedGamesGridComponent))
